import React, { Fragment, useEffect, useRef, useState } from 'react';
import { inject, observer } from 'mobx-react';
import shaka from 'shaka-player';

const ShakaPlayer = ({ videoRef }) => (
  <video
    controls
    playsInline
    autoPlay={false}
    ref={videoRef}
    style={{
      width: '100%',
      backgroundColor: '#f1f3f4',
      height: '92px'
    }}
    crossOrigin="anonymous"
  />
);

const onShakaError = (event) => {
  console.error('Shaka Error:', event.detail || event);
};

const MusicPlayer = ({ songsStore, currentSong }) => {
  const [player, setPlayer] = useState(null);
  const videoRef = useRef(null);

  // Create single Shaka player instance and register request filter
  useEffect(() => {
    shaka.polyfill.installAll();
    if (!shaka.Player.isBrowserSupported()) {
      console.error('Shaka Player is not supported in this browser.');
      return;
    }

    const p = new shaka.Player(videoRef.current);

    p.getNetworkingEngine().registerRequestFilter((type, request) => {
      const reqTypes = shaka.net.NetworkingEngine.RequestType;
      if (type === reqTypes.MANIFEST || type === reqTypes.SEGMENT) {
        request.allowCrossSiteCredentials = true;
      }
    });

    p.addEventListener('error', onShakaError);
    setPlayer(p);

    return () => {
      p.removeEventListener('error', onShakaError);
      p.destroy().catch(() => {});
    };
  }, []);

  // Load a new song when `currentSong` changes (guarded)
  useEffect(() => {
    if (!currentSong || !player || !videoRef.current) return;

    let cancelled = false;

    const loadSong = async () => {
      try {
        songsStore.activeSongRowID = currentSong.id;
        await player.load(`/assets/public/s3/song/${currentSong.streamFile}`);
        if (!cancelled) {
          try {
            await videoRef.current.play();
          } catch (playErr) {
            // autoplay may be blocked by browser; that's fine
            console.warn('Playback prevented:', playErr);
          }
        }
      } catch (err) {
        console.error('Error loading manifest:', err);
      }
    };

    loadSong();

    return () => {
      cancelled = true;
    };
  }, [currentSong, player, songsStore]);

  return (
    <Fragment>
      <div style={{ display: !!currentSong ? 'block' : 'none' }}>
        <ShakaPlayer videoRef={videoRef} />
      </div>
    </Fragment>
  );
};

export default inject('songsStore')(observer(MusicPlayer));